import React from 'react';

import ProgressBar from 'shared/components/progress-bar';

interface Props {
  gaugeInfo: {
    totalCredits: number;
    goalCredits: number;
  };
  color?: 'blue' | 'red';
}

const InProgressBar = ({gaugeInfo, color = 'blue'}: Props) => {
  const fillAmount = ((gaugeInfo.totalCredits / gaugeInfo.goalCredits) * 100).toFixed(0) + '%';

  return (
    <div className="on-track-in-progress-bar">
      <div className="on-track-in-progress-bar-container">
        <ProgressBar color={color} fillAmount={fillAmount} height={10} />
      </div>
      <div className="on-track-in-progress-bar-text-container">
        <span className="on-track-in-progress-bar-text">{`${gaugeInfo.totalCredits}/${gaugeInfo.goalCredits}`}</span>
      </div>
    </div>
  );
};

export default InProgressBar;
